import componentKeyMappings from '../common/config/ComponentKeyMappings'
import APIs from '../common/config/APIs'
import defaultRestApi from '../common/config/RestApiInstance'
import React from "react"
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import _ from "lodash"
import ErrorBoundary from '../common/boundary'
import Utils from "../common/Utils"
import Constants from '../common/Constants';


export default class TemplateServices {
   
    static getTemplatesAPI = () => {
        return defaultRestApi.get(APIs.templateLoadURL())
    }

    static getClickLogAPI = (query) => {
      return defaultRestApi.get(APIs.getClickLogURL(query))
    }

     static getTemplatesAPILocal = (skinName) => {
        return defaultRestApi.get(APIs.templateLoadURLLocal(skinName))
    }

    static initComponent = (nameComp, idKey, initialData, props) => {
        if(idKey == null){
            idKey = nameComp
        }
        let ComponentEle = componentKeyMappings[nameComp]
        if (ComponentEle != null) {
            return <ErrorBoundary key ={idKey+'_errorComp_'+nameComp} >
                        <ComponentEle key ={idKey} initialData ={initialData} {...props}></ComponentEle>
                    </ErrorBoundary>
        } else return null
    }

    static async loadTemplateData() {
        let resp = await this.getTemplatesAPI()        
        return this.initTemplateData(resp)       
    }

    static async loadTemplateDataFromLocal(templateName) {
        let resp = await this.getTemplatesAPILocal(templateName)
        let tempData = this.initTemplateData(resp)
        //// console.log("tempData", tempData)
        return  tempData  
    }

    /**
        This function stores a JSON object in local storage. The CMS module will then retrieve it to render the language list
    **/
    static initLanguagesForCMSModule() {
        localStorage.setItem('cmsLanguages', window.env.langSupports);
    }

    static initTemplateData(resp){
        let templateData = {};
        let templDetail = {};
        if(typeof resp.data.mbTemplate === 'string')
        {
            templDetail = JSON.parse(resp.data.mbTemplate);
        }
        else{
            templDetail = resp.data.mbTemplate;
        }
        
        templateData.attributes = resp.data.globalAttribute;
        window.env = resp.data.globalAttribute;
        this.initLanguagesForCMSModule();
        let initDataForComps = (resp.data.mbInitDataForComps)
        templateData.allComponents = []
        let headerContainer = templDetail.headerContainer;
        for (var viewKey in headerContainer) {
            this.pushComps(templateData.allComponents, headerContainer[viewKey])
        }
        templateData.headerContainer = templDetail.headerContainer;
        templateData.supportProduct = Utils.isEsportOnlyByBrand() || Utils.isSpecifyEsportsOnlyByBrand() || Utils.isEsportOnlyByLoginView()
          ? Constants.SUPPORT_PRODUCT_ONLY.ESPORTS 
          : templDetail.supportProduct;
        templateData.isBothSideBarOnRight = templDetail.isBothSideBarOnRight;
        templateData.isAccountInfo = templDetail.isAccountInfo;
        templateData.isNonNeader = false;
        templateData.templateType = templDetail.templateType;
        if(templDetail.templateType !== null && templDetail.templateType === Constants.TEMPLATE_TYPE.IFRAME){
            templateData.isNonNeader = true;
        }


        //-----------Body-------------------------//
        templateData.bodyContainer = {}
        templateData.bodyContainer = templDetail.bodyContainer;
        let bodyContainer = templateData.bodyContainer;
        for (var viewKey in bodyContainer) {
           //console.log("bodyContainer[view]: " + viewKey, bodyContainer[viewKey])
           let pages = bodyContainer[viewKey];
           for (var pageKey in pages) {
                //console.log("page: " +  pageKey, pages[pageKey])
                let positionsInPages = pages[pageKey];
                for (var positionsInPageKey in positionsInPages) {
                       // console.log(viewKey + " "+ pageKey + "positionsInPageKey: " +  positionsInPageKey, positionsInPages[positionsInPageKey]);
                        let comps = positionsInPages[positionsInPageKey];
                        //console.log("comps", comps)
                        this.pushComps(templateData.allComponents,  comps);
                }

           }
        }

       
       
       //--------------Footer-------------------//
        let footerComps = templDetail.footerContainer;

        for (var viewKey in footerComps) {
            this.pushComps(templateData.allComponents, footerComps[viewKey]);
        }

        this.updateCompsInitialData(templateData.allComponents, initDataForComps);
       //// console.log("templateData.allComponents", templateData.allComponents);
        
        templateData.footerContainer = footerComps;
        templateData.cssFile = templDetail.cssFiles[0];
        templateData.cssFontFile = templDetail.cssFontFiles[0].name;
        
        templateData.initDataForSkin = this.loadSharedComponentData('SharedComponent', resp.data.mbInitDataForComps);
        //console.log("templateData", templateData)
        return templateData
    }
    
    static loadSharedComponentData(sharedComponentName, dataAllComps) {
        var initDataForSkin = []
         _.forOwn(dataAllComps, function(comp, key) {
              //console.log("comp.componentName", comp.componentName)
               if(comp.componentName === sharedComponentName){
                    initDataForSkin = comp.initialData
                    return false;
               }
         });
        return initDataForSkin
    }

    /**
     * convert to React Components from data json
     * 
     */

    static listComponentsByData(data, auth, props) {
        let viewRow = []
        let rows = [];
        for(let i = 0; i < 10; i++){
           let componentsInRow = this.findComponentByRowIndex(data, i);
            // console.log("componentsInRow", componentsInRow)
           if(componentsInRow.length > 0){
               rows.push(componentsInRow);
           }          

        }

        // console.log("rows", rows)
        for(let key = 0; key < rows.length; key++){
                let row = rows[key];
                let viewComponents = []
                for(let i = 0; i < row.length; i++){
                    let ele = row[i];
                    let compName = ele.componentName;
                    let colClass = ele.colClass;
                    let idKey = compName;
                    let initialData = ele.initialData;
                    // console.log("ele", ele)

                    let compEle = this.initComponent(compName, idKey, initialData, props);		
                    viewComponents.push(
						<Col key={"col-" + i} className={colClass}>
							{compEle}
						</Col>
					)
                }
                viewRow.push(this.newRowComponent(viewComponents, key))

         };
         return viewRow
    }

    static findComponentByRowIndex(dataComponents, index) {
        let componentsInRow = _.filter(dataComponents, function(dataComp) {
                    return dataComp.rowIndex === index || (index === 0 && dataComp.rowIndex == null)
                });
        return componentsInRow
    }

    static newRowComponent(componentInRow, key) {
        return (
        <Row key={"row-" + key}>
            {componentInRow.map(comp => {
                return comp
            })}
        </Row>
    )
    }

    /**
     * convert to React Components from data json
     * 
     */
    static listComponentsByDataNoGrid(data, props) {  
        let objData = Utils.convertMobxObjToJsonObj(data);
        var comps = Object.keys(objData)       
		let listComponents = comps.map((key) => {
		    let compEle = null;
            let compName = data[key].componentName;
            let idKey = compName;
            let initialData = data[key].initialData;
            compEle = this.initComponent(compName, idKey, initialData, props);
            return <div key={key+'_components_nogrid'} className={compName+'_container'}>{compEle}</div>;
		});
		return listComponents;
	}

    /**
     * push new array to exist array
     */
    static pushComps(orgComps, newDataComps) {
        if (Array.isArray(newDataComps) && newDataComps.length > 0) {
            _.forOwn(newDataComps, function(comp, key) {
               // console.log("comp push", comp)
                orgComps.push(comp);
            });
        }      
       	   
	}
    /**
     * updateCompsInitialData
     * Add InitialData into each components
     *
     *
     */
    static updateCompsInitialData(dataComps, initDataForComps) {
        let newComps = [];
        let mapNameAndIntialData = new Map();

        _.forOwn(initDataForComps, function(comp, key) {
            if(typeof comp.initialData === 'string'){
                 mapNameAndIntialData.set(comp.componentName, JSON.parse(comp.initialData))
            }
            else{
                mapNameAndIntialData.set(comp.componentName, comp.initialData)
            }           
           
        });

        _.forOwn(dataComps, function(comp, key) {
            if(mapNameAndIntialData.get(comp.componentName) != null ){
                comp.initialData = mapNameAndIntialData.get(comp.componentName)
            }
            newComps.push(comp);
       });
       dataComps = newComps;
	}

    /**
     * load Componenta By Array Names In TemplateStore
     */
    static loadComponentByNameInTemplateStore(compNames, allCompsLayoutTemplateStore) {
        let compDetects = [];
        _.forOwn(allCompsLayoutTemplateStore, function (comp, key) {
            //// console.log("comp.componentName " + key, comp.componentName)
            if (compNames.indexOf(comp.componentName) > -1) {
                compDetects.push(comp);
            }
        });

        //// console.log("compDetects", compDetects)
        return this.listComponentsByDataNoGrid(compDetects)
    }

    /**
     * load Components By array names in template
     */
    static async loadComponentByNameInTemplate(compNames, templateName) {
        return this.loadComponentsInTemplate(templateName).then(res => {
            let templateData = res;
            let allCompsLayoutTemplateStore = templateData.allComponents;
            let compDetects = this.loadComponentByNameInTemplateStore(compNames, allCompsLayoutTemplateStore);
            //// console.log("nin - compDetect", compDetects);
            return compDetects
        })
       
    }

    /**
     * convert to React Components from data json
     * 
     */
    static listDataCompsByContainer(temmplateData, container, view, page, position) {  
        //// console.log("temmplateData", Utils.convertMobxObjToJsonObj(temmplateData))
        let currentView = view;
        if(temmplateData[container] == null) return []
        if(temmplateData[container][currentView] == null){
            //get asiaView if page have only asiaView
            console.info("view " + view + +"of page" + page + " is not config. So will load asiaView of this page");
            currentView = 'asiaView';
        }
        if(temmplateData[container][currentView] == null) return []
        if(temmplateData[container][currentView][page] == null) return []
        if(temmplateData[container][currentView][page][position] == null) return []
       return temmplateData[container][currentView][page][position];
	}
    /**
     * check fixed header by Page
     */
    static isThisPageFixedHeader(LayoutTemplateStore) {  
        //// console.log("temmplateData", Utils.convertMobxObjToJsonObj(temmplateData))
       let templateData = LayoutTemplateStore.templateData;
       let view = LayoutTemplateStore.currentViewContainer;
       let page = LayoutTemplateStore.currentPageContainer
       let isFixed = false;
       try{
           if(templateData.bodyContainer[view][page]['fixedHeader']){
               isFixed = templateData.bodyContainer[view][page]['fixedHeader']
           }
       }
       catch(error){

       }
       return isFixed
       
	}

    /**
     * listDataCompsByContainerPosition
     */
    static listDataCompsByContainerPosition(LayoutTemplateStore, container, position, page) {  
        //// console.log("temmplateData", Utils.convertMobxObjToJsonObj(temmplateData))
        try {
           let templateData = LayoutTemplateStore.templateData;
            let view = LayoutTemplateStore.currentViewContainer;
            if(page == null){
                page = LayoutTemplateStore.currentPageContainer;
            }
            return this.listDataCompsByContainer(templateData, container, view, page, position); 
        } catch (error) {
            console.error(error);
        }
       
	}

    /**
     * Detect view asia or euro or classic base on URL
     * 
     * window.APP_ROUTER_BASE was define in Routes
     */
    static getViewByURLPath () {
        
        let strUrl = window.location.href.replace(window.APP_ROUTER_BASE == null ? "":  window.APP_ROUTER_BASE , "");
        return this.getViewName(strUrl);
    }

    static getViewName (pathName){
        if (pathName == null) return 'euroView';
        let viewName = "euroView";
        if (pathName.includes("/asian/") || pathName.endsWith("/asian")) {
            viewName = "asiaView";
        } else if (pathName.includes("/classic/") || pathName.endsWith("/classic")) {
            viewName = "classicView";
        }
        return viewName;
    }


    static isThisPageUseMasterLayout(templateData, view ,page) {  
        try {
            return templateData['bodyContainer'][view][page].isUseMasterLayout || false;
        } catch (error) {
            return false;
        }
	}

}


// WEBPACK FOOTER //
// ./src/app/services/TemplateServices.js